var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 74 74",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M62.337 69.086H12.413a3.78 3.78 0 0 1-3.774-3.774V58.7a1 1 0 0 1 1-1h55.472a1 1 0 0 1 1 1v6.611a3.78 3.78 0 0 1-3.774 3.775M10.639 59.7v5.611a1.776 1.776 0 0 0 1.774 1.774h49.924a1.776 1.776 0 0 0 1.774-1.774V59.7zM31.417 28.006h-4.8a1 1 0 0 1-1-1v-2.843a2.52 2.52 0 0 1 2.52-2.521H29.9a2.523 2.523 0 0 1 2.521 2.521v2.843a1 1 0 0 1-1.004 1m-3.8-2h2.8v-1.843a.52.52 0 0 0-.521-.521h-1.754a.52.52 0 0 0-.52.521zM48.128 28.006h-4.8a1 1 0 0 1-1-1v-2.843a2.523 2.523 0 0 1 2.521-2.521h1.754a2.52 2.52 0 0 1 2.52 2.521v2.843a1 1 0 0 1-.995 1m-3.8-2h2.8v-1.843a.52.52 0 0 0-.52-.521h-1.754a.52.52 0 0 0-.521.521zM70.567 30.005a1 1 0 0 1-.233-.027l-15.082-3.6a1 1 0 1 1 .465-1.945l15.082 3.6a1 1 0 0 1-.232 1.972",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.844 34.671a3.35 3.35 0 0 1-3.325-2.9l-1.061-7.846a9.34 9.34 0 0 1 5.108-9.593C18.222 9.014 29.657 7.9 37.375 7.9c7.74 0 19.2 1.115 29.818 6.429a9.34 9.34 0 0 1 5.1 9.589l-1.062 7.85a3.35 3.35 0 0 1-4.1 2.812l-10.544-2.519a3.364 3.364 0 0 1-2.555-3.614l.6-5.7a2.125 2.125 0 0 0-1.667-2.289 71 71 0 0 0-31.138 0 2.126 2.126 0 0 0-1.666 2.289l.6 5.706a3.36 3.36 0 0 1-2.558 3.614L7.619 34.581a3.3 3.3 0 0 1-.775.09M37.375 9.9c-7.5 0-18.609 1.08-28.916 6.223a7.34 7.34 0 0 0-4.018 7.536L5.5 31.5a1.35 1.35 0 0 0 1.655 1.135l10.588-2.521a1.36 1.36 0 0 0 1.032-1.458l-.6-5.706a4.127 4.127 0 0 1 3.218-4.45 73 73 0 0 1 32.008 0 4.126 4.126 0 0 1 3.222 4.452l-.6 5.7a1.356 1.356 0 0 0 1.031 1.458l10.541 2.518a1.353 1.353 0 0 0 1.653-1.128l1.061-7.85a7.33 7.33 0 0 0-4.009-7.534C56.026 10.977 44.9 9.9 37.375 9.9",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.181 30.005a1 1 0 0 1-.231-1.972L19.2 24.39a1 1 0 1 1 .465 1.945l-15.25 3.643a1 1 0 0 1-.234.027M65.111 59.7H9.639a1 1 0 0 1-1-1v-9.548a6.63 6.63 0 0 1 3.615-5.925A18.1 18.1 0 0 0 22.13 29.58a4.13 4.13 0 0 1 4.1-3.58h22.288a4.13 4.13 0 0 1 4.1 3.58A18.1 18.1 0 0 0 62.5 43.227a6.63 6.63 0 0 1 3.615 5.925V58.7a1 1 0 0 1-1.004 1m-54.472-2h53.472v-8.548a4.62 4.62 0 0 0-2.5-4.133A20.1 20.1 0 0 1 50.64 29.864 2.14 2.14 0 0 0 48.518 28H26.232a2.14 2.14 0 0 0-2.122 1.864 20.1 20.1 0 0 1-10.967 15.155 4.62 4.62 0 0 0-2.5 4.133z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.375 54.694A11.145 11.145 0 1 1 48.52 43.549a11.157 11.157 0 0 1-11.145 11.145m0-20.29a9.145 9.145 0 1 0 9.145 9.145 9.156 9.156 0 0 0-9.145-9.149z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.375 38.452a1 1 0 0 1-1-1v-.62a1 1 0 1 1 2 0v.62a1 1 0 0 1-1 1M33.063 40.237a1 1 0 0 1-.706-.292l-.439-.438a1 1 0 1 1 1.414-1.415l.438.438a1 1 0 0 1-.707 1.707M31.277 44.549h-.619a1 1 0 1 1 0-2h.619a1 1 0 0 1 0 2M32.625 49.3a1 1 0 0 1-.707-1.708l.439-.438a1 1 0 0 1 1.413 1.415l-.438.438a1 1 0 0 1-.707.293M37.375 51.267a1 1 0 0 1-1-1v-.62a1 1 0 1 1 2 0v.62a1 1 0 0 1-1 1M42.125 49.3a1 1 0 0 1-.707-.293l-.438-.438a1 1 0 1 1 1.413-1.415l.439.438a1 1 0 0 1-.707 1.708M44.092 44.549h-.619a1 1 0 0 1 0-2h.619a1 1 0 0 1 0 2M41.687 40.237a1 1 0 0 1-.707-1.707l.438-.438a1 1 0 1 1 1.414 1.415l-.439.438a1 1 0 0 1-.706.292",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.2053759c7095ef2bb85d91c206d99e3e.svg";
export { ForwardRef as ReactComponent };